import { isMobile, IONICWrapper } from "../../../utils/common";
export const defaultDataUncheck = [
  {
    value: {
      none: "false",
      sms: "true",
      email: "true",
      "inapp-notifications": "true"
    },
    key: "preferredcontact",
    domain: null,
    useractionrequired: null
  },
  {
    value: {
      "Early Morning": "true",
      "Late Morning": "false",
      "Early Afternoon": "true",
      "Late Afternoon": "false"
    },
    key: "preferredtime",
    domain: null,
    useractionrequired: null
  },
  {
    value: {
      Weekdays: "true",
      Weekends: "false"
    },
    key: "preferreddaysofweek",
    domain: null,
    useractionrequired: null
  }
];
export const defaultDataCheck = [
  {
    value: {
      none: "true",
      sms: "false",
      email: "false",
      "inapp-notifications": "false"
    },
    key: "preferredcontact",
    domain: null,
    useractionrequired: null
  },
  {
    value: {
      "Early Morning": "false",
      "Late Morning": "false",
      "Early Afternoon": "false",
      "Late Afternoon": "false"
    },
    key: "preferredtime",
    domain: null,
    useractionrequired: null
  },
  {
    value: {
      Weekdays: "false",
      Weekends: "false"
    },
    key: "preferreddaysofweek",
    domain: null,
    useractionrequired: null
  }
];
export const defaultDataUncheckforMarTech = [
  {
    value: {
      none: "false",
      sms: "false",
      email: "true",
      "inapp-notifications": "false"
    },
    key: "preferredmarketingcommunications",
    domain: null,
    useractionrequired: null
  },
];
export const defaultDataCheckforMarTech = [
  {
    value: {
      none: "true",
      sms: "false",
      email: "false",
      "inapp-notifications": "false"
    },
    key: "preferredmarketingcommunications",
    domain: null,
    useractionrequired: null
  },
];
export const PreferenceViewValidation = (
  ACCORD_ROLE_FILTER_KEY: string,
  SUB_MODULE: boolean = false,
  SUB_MODULE_KEY: string | null = null
) => {
  let isValid: boolean = false;
  const userRoles =
    IONICWrapper.details &&
    IONICWrapper.details.auth &&
    IONICWrapper.details.auth.user &&
    IONICWrapper.details.auth.user.roles &&
    IONICWrapper.details.auth.user.roles;
  const preferenceRoleFilter =
    IONICWrapper &&
    IONICWrapper.details &&
    IONICWrapper.details.keys &&
    IONICWrapper.details.keys.configuration &&
    IONICWrapper.details.keys.configuration.preference_role_filter;
  if (SUB_MODULE && SUB_MODULE_KEY) {
    preferenceRoleFilter &&
      preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY] &&
      preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].SUB_MODULE &&
      preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].SUB_MODULE[SUB_MODULE_KEY] &&
      Object.entries(
        preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].SUB_MODULE[SUB_MODULE_KEY]
      ).forEach(([key, value]) => {
        userRoles.forEach((role: any) => {
          if (role === key && value) isValid = true;
        });
      });
  } else {
    if (isMobile) {
      preferenceRoleFilter &&
        preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY] &&
        preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].mobile &&
        Object.entries(
          preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].mobile
        ).forEach(([key, value]) => {
          userRoles.forEach((role: any) => {
            if (role === key && value) isValid = true;
          });
        });
    } else {
      preferenceRoleFilter &&
        preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY] &&
        preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].web &&
        Object.entries(
          preferenceRoleFilter[ACCORD_ROLE_FILTER_KEY].web
        ).forEach(([key, value]) => {
          userRoles.forEach((role: any) => {
            if (role === key && value) isValid = true;
          });
        });
    }
  }

  return isValid;
};

export const NoneChecker = (payload: any) => {
  let isNone = false;
  payload.forEach((element: any) => {
    if (element.key === "preferredcontact") {
      const { none, ...rest } = element.value;
      if (
        none === "true" ||
        Object.values(rest).findIndex((value: any) => value === "true") === -1
      ) {
        isNone = true;
      }
    }
  });
  return isNone;
};
export const NoneCheckerforMarTech = (payload: any) => {
  let isNoneMarTech = false;
  payload.forEach((element: any) => {
    if (element.key === "preferredmarketingcommunications") {
      const { none, ...rest } = element.value;
      if (
        none === "true" ||
        Object.values(rest).findIndex((value: any) => value === "true") === -1
      ) {
        isNoneMarTech = true;
      }
    }
  });
  return isNoneMarTech;
};
export const toggeler = (type: string) => (type === "true" ? "false" : "true");
export const BooleanDataCheck = (data: string): boolean =>
  data === "true" ? true : false;
export const PreferenceCapacityTypeSetup = (storeData: any) => {
  const capacityTypeDBvalue: any = storeData && storeData.filter((item: any, index: any) => {
    if (item.key === "preferredcapacitytype") {
      return item;
    }
  });
  return capacityTypeDBvalue && capacityTypeDBvalue[0];
};

export const PreferenceCapacityValueChange = (value: any) => {
  if (value === "PowerOnly") {
    return "Power Only";
  }

  if (value === "Dryvan") {
    return "Dry Van";
  }

  if (value === "Refrigerator") {
    return "Refrigerated";
  }

  if (value === "specialized") {
    return "Specialty";
  }
  if (value === "Dray") {
    return "Dray";
  }
  return value;
};

export const isUnsave = (
  ACORD_CONTENT: any,
  userInteractedPreferenceList: any[]
) => {
  if (ACORD_CONTENT.length > 0 && userInteractedPreferenceList.length > 0) {
    return ACORD_CONTENT.map((elem: any) =>
      userInteractedPreferenceList.some(
        (item: any) => item.key === elem.API_KEY
      )
    ).some((i: any) => i);
  }
};
